import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  // BD邀请
  {
    path: '/saada/bd/invite',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-bd-invite" */ '~/pages/saada/BD/pages/invite'
        )
    ),
  },
  // BD中心
  {
    path: '/saada/bd/center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-bd-center" */ '~/pages/saada/BD/pages/center'
        )
    ),
  },
  // 首充
  {
    path: '/saada/FirstCharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-FirstCharge" */ '~/pages/saada/FirstCharge'
        )
    ),
  },
  {
    // 聊天收益
    path: '/chat-income',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-chatIncome" */ '~/pages/saada/chatIncome'
        )
    ),
  },
  {
    // 男用户激励
    path: '/manPower',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-manPower" */ '~/pages/saada/manPower'
        )
    ),
  },
  {
    // 新手任务
    path: '/new-user-task',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-newUserTask" */ '~/pages/saada/newUserTask'
        )
    ),
  },
  {
    // 等级中心
    path: '/level-center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-levelCenter" */ '~/pages/saada/levelCenter'
        )
    ),
  },
  {
    // 等级中心规则
    path: '/level-center/rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-levelCenter-Rules" */ '~/pages/saada/levelCenter/Rules'
        )
    ),
  },
  {
    // 等级中心规则
    path: '/level-center/rules/:currentKey',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-saada-levelCenter-Rules" */ '~/pages/saada/levelCenter/Rules'
        )
    ),
  },
] as RouteConfig[]
